import { css } from 'styled-components';
import { spacingMixin } from '@zillow/constellation';

/** @class ProgressBarMixin */
/** @method */
export const ProgressBarMixin = (props) => {
    const { percentComplete } = props;
    return css`
            ${spacingMixin};
            width: 50%;
            align-self: center;
            border-radius: 4px;
            background-color: rgb(209, 209, 213);

            &::before {
                border-radius: 4px;
                content: '';
                display: block;
                background-color: rgb(0, 106, 255);
                width: ${percentComplete}%;
                height: 4px;
                transition: width 0.5s ease-in-out;
            }
        `;
};
